import { FC, FormEvent, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { z } from 'zod'
import { AgentModel } from '../../models/agent'
import { RootReducers } from '../../redux/reducers'
import { BranchList } from '../branchList'
import { LoadingOverlay } from '../loadingOverlay'
import classes from './ModalAddStaff.module.css'
import { errorMessageFormSchema } from '../../constants/errorMessage'
import * as staffAction from '../../redux/actions/staff.action'
import * as errorAction from '../../redux/actions/error.action'
import { isAxiosError } from 'axios'

export const AddStaffSchema = z.object({
  name: z.string().min(1, errorMessageFormSchema.required),
  staffId: z.string().min(1, errorMessageFormSchema.required),
  email: z.string().email(errorMessageFormSchema.invalidEmail).trim(),
  branch: z.string().min(1, errorMessageFormSchema.required)
})

export interface ModalAddStaffProps {
  isOpen?: boolean
  onCancel?: () => void
  onSuccess?: () => void
}

export const ModalAddStaff: FC<ModalAddStaffProps> = ({ isOpen = false, onCancel, onSuccess }) => {
  const dispatch = useDispatch()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<any>()
  const formRef = useRef<HTMLFormElement>(null)

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const formJson = Object.fromEntries(formData)
    const result = AddStaffSchema.safeParse(formJson)
    if (result.success) {
      try {
        setError(undefined)
        setSubmitting(true)

        await dispatch(
          staffAction.createNewStaff({
            ...result.data,
            createBy: loginState.account?.agentInfo.name
          })
        )
        onSuccess?.()
        setSubmitting(false)
      } catch (error) {
        onCancel?.()
        setSubmitting(false)
        if (isAxiosError(error)) {
          const errorMessage = error.response?.data?.message || error.message
          dispatch(errorAction.setError(new Error(errorMessage)))
          return
        }

        dispatch(errorAction.setError(error))
      }
    } else {
      const formated = result.error.format()
      setError(formated)
    }
  }

  const resetForm = () => {
    setError(undefined)
    formRef.current?.reset()
  }

  const ErrorMessage = ({ name }: { name: string }) => {
    const findError = error?.[name]?._errors
    return <div className={classes.ErrorMessage}>{findError?.[0]}</div>
  }

  useEffect(() => {
    if (!isOpen) {
      resetForm()
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      style={{
        content: {
          width: 570,
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: 30,
          borderRadius: 15
        },
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(24, 48, 40, 0.9)'
        }
      }}
      ariaHideApp={false}
    >
      {submitting && <LoadingOverlay />}
      <form onSubmit={onSubmit} ref={formRef}>
        <div className="modal-cancel-header-text">เพิ่มพนักงานใหม่</div>
        <div className={classes.FormInput}>
          <div className={classes.FormGroup}>
            <label htmlFor="name">ชื่อ</label>
            <input type="text" name="name" id="name" className="field-input" />
            <ErrorMessage name="name" />
          </div>
          <div className={classes.FormGroup}>
            <label htmlFor="staffId">รหัสพนักงาน</label>
            <input type="text" name="staffId" id="staffId" className="field-input" />
            <ErrorMessage name="staffId" />
          </div>
        </div>
        <div className={classes.FormInput}>
          <div className={classes.FormGroup}>
            <label htmlFor="email">email</label>
            <input type="email" name="email" id="email" className="field-input" />
            <ErrorMessage name="email" />
          </div>
          <div className={classes.FormGroup}>
            <label htmlFor="branch">สาขา</label>
            <BranchList
              agentData={loginState.account?.agentInfo as AgentModel}
              isGetBranchId={true}
              name="branch"
              id="branch"
            />
            <ErrorMessage name="branchName" />
          </div>
        </div>
        <div className={classes.ModalActions}>
          <button type="button" className="cancel-transaction-button" onClick={onCancel}>
            ยกเลิก
          </button>
          <button type="submit" className="confirm-transaction-button">
            ยืนยัน
          </button>
        </div>
      </form>
    </Modal>
  )
}
